import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import MaintenancePage from './MaintenancePage';
import reportWebVitals from './reportWebVitals';

const maintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';
const previewKey = process.env.REACT_APP_MAINTENANCE_PREVIEW_KEY || 'smartdoctors';
const previewEnabled = new URLSearchParams(window.location.search).get('preview') === previewKey;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {maintenanceMode && !previewEnabled ? <MaintenancePage /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
